export default "__VITE_ASSET__8H1kz3uk__"